<div class="col-12 md:col-12 p-2"><h3>{{'Notify_N' | translate}}</h3></div>
<p-tabView [activeIndex]="activeIndex">
  @for (tab of tabs; track tab; let i = $index) {
    <p-tabPanel [selected]="i == 0">
      <ng-template pTemplate="header">
        <span>{{tab.title}}</span>
      </ng-template>
      <div class="p-fluid">
        <div class="grid">
          @if (tab.currentNotifList.length ===0) {
            <div><p>{{'Empty' | translate}}</p></div>
          }
          @for (item of tab.currentNotifList; track item; let i = $index) {
            <!-- @if (item.typenotif === 4 || item.typenotif === 6) {
              <div class="col-6 font-bold">{{ item.fromlogin }}</div>
            } -->
            <!-- @if (item.typenotif === 0 || item.typenotif === 1 || item.typenotif === 2 || item.typenotif === 3
              || item.typenotif === 5) {
              <div class="col-6">{{ item.datanotif | truncate}}</div>
            } -->
            <div class="col-3">{{ item.datenotif | date: 'dd/MM/yyyy HH:mm:ss'}}</div>
            @switch(item.typenotif) {
              @case (0) {
                <div class="col-6">{{ item.datanotif | truncate}}</div>
                <i pTooltip="{{'Batch_Type_0' | translate}}" class="col-1 icons8-statistiques md-18"></i>
              }
              @case (1) {
                <div class="col-6">{{ item.datanotif | truncate}}</div>
                <i pTooltip="{{'Batch_Type_1' | translate}}" class="col-1 icons8-pdf md-18"></i>
              }
              @case (2) {
                <div class="col-6">{{ item.datanotif | truncate}}</div>
                <i pTooltip="{{'Batch_Type_2' | translate}}" class="col-1 icons8-versions md-18"></i>
              }
              @case (3) {
                <div class="col-6">{{ item.datanotif | truncate}}</div>
                <i pTooltip="{{'Batch_Type_3' | translate}}" class="col-1 icons8-exporter md-18"></i>
              }
              @case (4) {
                <div class="col-6 font-bold">{{ item.fromlogin }}</div>
                <i pTooltip="{{'Notify' | translate}}" class="col-1 pi pi-comment md-18"></i>          
                <div class="col-2">
                  <button
                    class="cust-width"
                    type="button" pButton
                    pTooltip="{{'Notif_Resp' | translate}}"
                    icon="pi pi-reply"
                    (click)="onAnswer($event, item, i)"
                  ></button>
                </div>
                <p class="col-12 white-space bg-color">{{item.mess}}</p>
              }
              @case (5) {
                <div class="col-6">{{ item.datanotif | truncate}}</div>
                <i pTooltip="{{'Batch_Type_4' | translate}}" class="col-1 icons8-exporter md-18"></i>
              }
              @case (6) {
                <div class="col-6 font-bold">{{ item.fromlogin }}</div>
                <i pTooltip="{{'Notify' | translate}}" class="col-1 pi pi-comment md-18"></i>          
                <div class="col-2">
                  <button
                    class="cust-width p-button-success"
                    type="button" pButton
                    pTooltip="{{'Acquir' | translate}}"
                    icon="pi pi-check"
                    (click)="onCheck($event, item, i)"
                  ></button>
                </div>
                <p class="col-12 white-space bg-color">{{item.mess}}</p>
              }
            }
            <!-- @if (item.typenotif === 4 || item.typenotif === 6) {
              <i pTooltip="{{'Notify' | translate}}" class="col-1 pi pi-comment md-18"></i>          
              <div class="col-2">
                @if (item.typenotif ===4) {
                  <button
                    class="cust-width"
                    type="button" pButton
                    pTooltip="{{'Notif_Resp' | translate}}"
                    icon="pi pi-reply"
                    (click)="onAnswer($event, item, i)"
                  ></button>
                }
                @if (item.typenotif ===6) {
                  <button
                    class="cust-width p-button-success"
                    type="button" pButton
                    pTooltip="{{'Acquir' | translate}}"
                    icon="pi pi-check"
                    (click)="onCheck($event, item, i)"
                  ></button>
                }
              </div>
            } -->
            @if (item.typenotif === 0 || item.typenotif === 1 || item.typenotif === 2 || item.typenotif === 3
              || item.typenotif === 5) {
              <div class="col-2">
                @if (item.statenotif === 7) {
                  <button
                    class="cust-width p-button-danger"
                    type="button" pButton
                    pTooltip="{{'Delete' | translate}}"
                    icon="pi pi-trash"
                    (click)="onDelete($event, item)"
                  ></button>
                }@else {
                  <button
                    class="cust-width p-button-success"
                    type="button" pButton
                    icon="pi pi-download"
                    pTooltip="{{'DwnL' | translate}}"
                    (click)="onDownLoad($event, item)"
                  ></button>
                }
              </div>
            }
            <!-- @if (item.typenotif === 4 || item.typenotif === 6) {
              <p class="col-12 white-space bg-color">{{item.mess}}</p>
            } -->
          }
        </div>
      </div>
    </p-tabPanel>
  }
</p-tabView>

<p-dialog
  [contentStyle]="{ overflow: 'auto' }"
  [styleClass]="'sm:col-10 md:col-10 lg:col-10 xl:col-10'"
  [(visible)]="visibleNotif"
  [dismissableMask]="false"
  [modal]="true"
  [closable]="true"
  appendTo="body"
  >
  <ng-template pTemplate="header">
    <span class="p-dialog-title">
      {{'Notif_RespTo' | translate}} {{destUser}}
    </span>
  </ng-template>
  <div class="grid col-12 md:col-12 lg:col-12">
    <div class="col-12 md:col-5 lg:col-5">
    <commentaires class="linepad col-12 md:col-12 lg:col-12"
        [docId]="docId"
        [scroll]="true"
        [addComm]="true"
        [addNotif]="true"
        [userList]= "userList"
        [displayUserList]="false"
        (onSave)="onClickSend($event)"
      ></commentaires>
      <div class="col-12 md:col-12 align-right">
        <button
          type="button"
          pButton
          class="margin p-button-secondary"
          (click)="onClickEnd()"
          label="{{'End_Act' | translate}}"
        ></button>
      </div>
    </div>
    <div class="col-12 md:col-7 lg:col-7 max-pdf-nat innerpdf">
      <div style="position: relative; width: 100%; height: 100%;">
        <pdf-preview [pathPdf]="pathPdf" style="position: relative"></pdf-preview>
      </div>
    </div>
  </div>
</p-dialog>

